import createCache from "@emotion/cache";
export default createCache({
  key: "css"
});